function trackFB(value, currency, id, type, name) {
  let value1 = parseFloat(value).toFixed(2);

  fbq("track", "AddToCart", {
    value: value1,
    currency: currency,
    content_ids: id,
    content_type: "product_group",
    content_name: name,
    content_category: type,
  });
}

function initiateCheckout(value, currency, ids, items) {
  const formatted = ids;
  const formattedItems = items.replace("'", "").split(",");

  if (false == !!sessionStorage.getItem("first_sub")) {
    let number = parseFloat(value.split(",").join(""));
    let price = number.toFixed(2);

    fbq("track", "InitiateCheckout", {
      value: price,
      currency: currency,
      content_ids: formatted,
      content_name: formattedItems,
      content_type: "product_group",
    });

    sessionStorage.setItem("first_sub", true);
  }
}

function writeRemoved(variantID) {
  jQuery.getJSON("/cart.js", function (data) {
    if (data.item_count > 0) {
      var ceUpdateCart = new CustomEvent("cart-update-custom", {
        detail: data,
      });
      window.dispatchEvent(ceUpdateCart);
    }
  });

  const variantId = window.item_to_add_variant_id
    ? window.item_to_add_variant_id
    : 32755132825705;

  if (variantId == variantID) {
    sessionStorage.setItem("RemovedItem", variantID);
    removeItemFromCart(variantId, 0);
  }
}

function appendAdd() {
  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
    navigator.userAgent
  )
    ? true
    : false;

  if (isMobile) {
    $(".Product__InfoWrapper").append($(".ProductForm__AddToCart"));
  }
}

function BisServer() {
  $(".second_notify").on("click", function () {
    var $parent = $(this).closest(".ProductItem__Wrapper");

    window.theme.subline = $(".product_item--extra", $parent).text();
  });

  if ($(".product_subtitle").length > 0) {
    window.theme.subline = $(".product_subtitle:first").text();
  }
}

function changeA() {
  $(".change--contact").click(function () {
    $("#Email").prop("disabled", function (i, v) {
      return !v;
    });
    $("#Phone").prop("disabled", function (i, v) {
      return !v;
    });
    const x = $(".change--contact").attr("data-action");
    if (x == "change") {
      $(".change--contact").html("SAVE");
      $(".change--contact").attr("data-action", "save");
    } else {
      $(".change--contact").html("CHANGE");
      $(".change--contact").attr("data-action", "change");
    }
  });
}

function seeNews() {
  var $div = $(".logoCarousel--wrapper");
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === "class") {
        var attributeValue = $(mutation.target).prop(mutation.attributeName);
      }
    });
  });
  observer.observe($div[0], {
    attributes: true,
  });

  $div.addClass("red");
}

function isMobile() {
  const width = $(window).width();
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
    navigator.userAgent
  )
    ? true
    : width < 1025;
  return isMobile;
}

function productAddedToCart(data) {
  const addToCart = parseInt(data.detail.quantity);
  const currentTotal = parseInt($(".Header__CartNumber:eq(0)").text());
  const newTotal = currentTotal + addToCart;
  //changeCartNumberVisibility(currentTotal, newTotal);

  if ($("#CustomCart__Recommendations").length != 0) {
    renderCartRecommendations();
  }
}

document.addEventListener("search:loaded", function (data) {
  hideSearchBarButtons();
});

document.addEventListener("product:added", function (data) {
  productAddedToCart(data);
});

document.addEventListener("product:added_custom", function (data) {
  $("#CustomCart__Recommendations").css("display", "none");
  productAddedToCart(data);
});

function handleATCSubmit(event) {
  event.preventDefault();

  document.dispatchEvent(new CustomEvent("theme:loading:start"));

  var addToCartButton = $(".ProductForm__AddToCart");
  addToCartButton.attr("disabled");

  const serializedArray = $(this).serializeArray();
  const data = serializedArray.reduce((acc, val) => {
    acc[val.name] = val.value;

    return acc;
  }, {});

  fetch(window.theme.localeRootUrl + "/cart/add.js", {
    body: JSON.stringify(data),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent("theme:loading:end"));
    if (response.ok) {
      addToCartButton.removeAttr("disabled");

      document.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: data.id,
            quantity: data.quantity,
          },
        })
      );
    } else {
      response.json().then(function (content) {
        var errorMessageElement = document.createElement("span");
        errorMessageElement.className = "ProductForm__Error Alert Alert--error";
        errorMessageElement.innerHTML = content["description"];
        addToCartButton.removeAttribute("disabled");
        addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
        setTimeout(function () {
          errorMessageElement.remove();
        }, 2500);
      });
    }
  });
}

function closeAllDropdowns() {
  // Close all open dropdowns
  document.querySelectorAll('.dropdown-content.show').forEach((dropdown) => {
    dropdown.classList.remove("show");
  });

  // Remove 'openDrop' and 'dropSelected' classes from all buttons
  document.querySelectorAll('.dropbtn.openDrop').forEach((button) => {
    button.classList.remove("openDrop");
  });
}

function toggleDropdown(buttonId, dropdownId) {
  const dropdown = document.getElementById(dropdownId);
  const button = document.getElementById(buttonId);
  
  // Close all dropdowns before toggling the new one
  closeAllDropdowns();
  
  // If the dropdown is not already open, open it
  if (dropdown && !dropdown.classList.contains("show")) {
    dropdown.classList.add("show");
    button.classList.add("openDrop");
  }
}

document.querySelectorAll('.dropbtn').forEach((button) => {
  button.addEventListener('click', function(event) {
    event.stopPropagation();  // Prevent the click from propagating to the document
    const dropdownId = this.dataset.dropdownId;
    toggleDropdown(this.id, dropdownId);
  });
});

document.querySelectorAll('.dropdown-content label').forEach((label) => {
  label.addEventListener('click', function() {
    const dropdown = this.closest('.dropdown-content');
    const buttonId = dropdown.dataset.buttonId;

    // Debugging: Check if buttonId is correct
    // console.log('Button ID:', buttonId);
    
    const button = document.getElementById(buttonId);
    
    // Debugging: Check if the button is found
    if (!button) {
      console.error('Button not found for ID:', buttonId);
      return; // Exit if button is not found
    }

    // Update button text with the selected value
    button.querySelector('span').textContent = this.textContent;

    // Add the 'dropSelected' class to the parent of the button
    button.closest('.variants').classList.add('dropSelected');

    // Close the dropdown immediately after selection
    closeAllDropdowns();
  });
});


// Close dropdown if clicking outside the dropdown
document.addEventListener('click', function() {
  closeAllDropdowns();
});

// Prevent dropdown from closing when clicking inside
document.querySelectorAll('.dropdown-content').forEach((dropdown) => {
  dropdown.addEventListener('click', function(event) {
    event.stopPropagation();  // Prevent the event from propagating to the document
  });
});





function searchonscroll() {
  const x = $("#Search2R .Search__Results").attr("aria-hidden");

  if (x == "false") {
    $(".Search__Form").trigger("reset");
    $("#Search2R .Search__Results").attr("aria-hidden", "true");
  }
}

$(document).ready(function () {
  var xl = sessionStorage.getItem("cartCount");

  if (xl) {
    $(".Header__CartCount").html("(" + xl + ")");
  } else {
    //  $('.Header__CartCount').html("(0)");
  }

  BisServer();
  changeA();

  videoPlayerInicialization();
});

$(document).scroll(function () {
  searchonscroll();
});

function changeImage(image) {
  var offset = 0;
  var offsetI = 0;
  offsetI = $(".Product__Slideshow .is-selected").position().top;
  offset = $("#Image" + image).position().top;
  $(".Product__Gallery .Product__Slideshow").animate(
    {
      scrollTop: offset - offsetI + "px",
    },
    500
  );
}

function videoPlayerInicialization() {
  if ($(".wrapper_click--video").length > 0) {
    $(".wrapper_click--video").each(function (index) {
      var options = JSON.parse(
        $(".video-js", this).attr("data-section-settings")
      );
      var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
        navigator.userAgent
      )
        ? true
        : false;

      let img_plh = "";
      let aspect_ratio = "";
      let src = "";
      if (isMobile) {
        if (options["control_var"]) {
          src = options["videom"];
        } else {
          src = options["videom"]["sources"][1]["url"];
        }
        img_plh = options["plh_mob"];
        if (options["aspect"]) {
          aspect_ratio = options["aspect"];
        } else {
          aspect_ratio = "9:16";
        }
      } else {
        if (options["control_var"]) {
          src = options["videod"];
        } else {
          src = options["videod"]["sources"][1]["url"];
        }
        img_plh = options["plh_desk"];
        if (options["aspect"]) {
          aspect_ratio = options["aspect"];
        } else {
          aspect_ratio = "16:9";
        }
      }


        if (isMobile && options['autoplay_hover']) {
          options['autoplay'] = true;
        }
      

      const payload = {
        aspectRatio: aspect_ratio,
        autoplay: options["autoplay"],
        muted: options["muted"],
        loop: options["loop"],
        controls: options["controls"],
        poster: img_plh,
        preload: "automatic",
        playsinline: true,
        responsive: true,

        disablePictureInPicture: true,
        controlBar: {
          playToggle: true,
          captionsButton: false,
          chaptersButton: false,
          subtitlesButton: false,
          remainingTimeDisplay: false,
          pictureInPictureToggle: false,
          volumeControl: false,
          progressControl: {
            seekBar: false,
          },
          fullscreenToggle: false,
          playbackRateMenuButton: false,
        },
        sources: [
          {
            type: "video/mp4",
            src: src,
          },
        ],
      };
      var videoplayerID = "my-player-" + options["id"];

      videojs(videoplayerID, payload);

      const parent = $(this).closest('.collectionSubcategories--Block');
      if (options['autoplay_hover'] && !isMobile){
        parent.mouseover(function() {
       
          if($('video', this)){
            var myPlayer = videojs(videoplayerID);
            myPlayer.play();
          }

        });

        parent.mouseleave(function() {
     
          if($('video', this)){
            var myPlayer = videojs(videoplayerID);
            myPlayer.pause();
          }

        });
    
      }

      $(this).css("display", "block");
      if (options['pause'] && !options['viewport']){
        pauseifout();
      }
      if (options["viewport"]) {
        waitforviewport(options["pause"]);
      }
    });

    toggleVideo();
  }
}

function toggleVideo() {
  $(".wrapper_click--video").on("click", function () {
    var id = $(this).attr("data-id");
    var videoplayerID = "my-player-" + id;
    var myPlayer = videojs(videoplayerID);

    if (myPlayer.paused()) {
      $(this).attr("data-pause", true);
      $(".vjs-poster", this).css("display", "inline-block");
    } else {
      $(".vjs-poster", this).css("display", "none");

    }
  });


}

function pauseifout() {

  var viewportHeight = $(window).height();
  $(window).on("scroll", function () {
    $(".wrapper_click--video").each((index, el) => {
      const id = $(el).attr("data-id");
      var customID = "my-player-" + id;

      var myPlayer = videojs(customID);

      var inner = $("#" + customID);

      var innerH = inner.outerHeight();
      innerH = innerH * 0.5;

      var elementPosTop = inner.position().top - innerH;
      if (elementPosTop < 0) {
        elementPosTop =
          inner.closest(".shopify-section").position().top - innerH;
      }

      var elementPosBot = elementPosTop + inner.outerHeight() + 200;
      var scrollPos = $(window).scrollTop();
      var elementFromTop = elementPosTop - scrollPos;

      if (
        (elementFromTop > 0 &&
          elementFromTop < elementPosTop + viewportHeight) ||
        (elementPosBot < scrollPos)
      ) {
 
        myPlayer.pause();
        $("." + customID + " .vjs-poster").css("display", "inline-block");
      }
    });
  });

}


function waitforviewport(pauseifout) { 
  var viewportHeight = $(window).height();
  $(window).on("scroll", function () {
    $(".wrapper_click--video").each((index, el) => {
      const id = $(el).attr("data-id");
      var customID = "my-player-" + id;

      var myPlayer = videojs(customID);

      var inner = $("#" + customID);

      var innerH = inner.outerHeight();
      innerH = innerH * 0.5;

      var elementPosTop = inner.position().top - innerH;
      if (elementPosTop < 0) {
        elementPosTop =
          inner.closest(".shopify-section").position().top - innerH;
      }

      var elementPosBot = elementPosTop + inner.outerHeight() + 200;
      var scrollPos = $(window).scrollTop();
      var elementFromTop = elementPosTop - scrollPos;
      var manual = $(el).attr("data-pause");

      if (
        (elementFromTop > 0 &&
          elementFromTop < elementPosTop + viewportHeight) ||
        (elementPosBot < scrollPos && pauseifout)
      ) {
    
        myPlayer.pause();
        $("." + customID + " .vjs-poster").css("display", "inline-block");
      } else {
        if (!manual) {
          myPlayer.play();
          $("." + customID + " .vjs-poster").css("display", "none");
        }
      }
    });
  });
}

function cartEventHandler(event) {
  var data = event.detail;
  const prodId = window.item_to_add_prod_id
    ? window.item_to_add_prod_id
    : 4780136890473;
  const variantId = window.item_to_add_variant_id
    ? window.item_to_add_variant_id
    : 32755132825705;

  const promotionTresholdType = window.promotion_treshold_type
    ? window.promotion_treshold_type
    : 1;
  const promotionLimit = window.promotion_sample_treshold
    ? window.promotion_sample_treshold
    : 100000;
  const promotinoQunatityTreshod = window.promotion_qunatity_treshold
    ? window.promotion_qunatity_treshold
    : 1;

  if (!window.hasPromotionSample) {
    return;
  }

  var manualRemove = sessionStorage.getItem("RemovedItem");
  const promotionInCart = checkCartForItem(prodId, data);

  //add promotion to cart
  const notPromotionAndNotRemoted =
    !promotionInCart && manualRemove != variantId;
  const promotinoTypeLimit =
    promotionTresholdType === 1 && data.items_subtotal_price >= promotionLimit;
  const promotionTypeQuantity =
    promotionTresholdType === 2 && data.item_count >= promotinoQunatityTreshod;

  if (
    promotionInCart &&
    ((promotionTresholdType === 1 &&
      data.items_subtotal_price < promotionLimit) ||
      (promotionTresholdType === 2 &&
        data.item_count - 1 < promotinoQunatityTreshod))
  ) {
    removeItemFromCart(variantId, 0);
    //  if(location.pathname === '/cart'){
    //location.reload()
    //}
  } else if (
    !promotionInCart &&
    manualRemove != variantId &&
    ((promotionTresholdType === 1 &&
      data.items_subtotal_price > promotionLimit) ||
      (promotionTresholdType === 2 &&
        data.item_count >= promotinoQunatityTreshod))
  ) {
    addPromotinoItem(prodId, variantId);
  } //else if(location.pathname === '/cart'){
  //location.reload()
  //  }
}

function dispatchCartEvent(data) {
  var ceUpdateCart = new CustomEvent("custom-cart-update-callback", {
    detail: data,
  });
  window.dispatchEvent(ceUpdateCart);
}

function addItemToCart(variant_id, qty, properties) {
  var qty = qty || 1;

  var params = {};
  params[variant_id] = qty;

  jQuery.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: { updates: params },
    dataType: "json",
    success: function (response) {
      //if(location.pathname === '/cart'){
      //location.reload()
      //  }else{
      dispatchCartEvent(response);

      CartService.get(Date.now()).then((cart) => {
        const loadingBar = $(".LoadingBar");
        loadingBar.css("width", "100%");

        const cartElement = $($.parseHTML(cart));
        const drawerElement = cartElement.find("form");

        const drawerHtml = drawerElement.html();

        const cartFormElement = $("#sidebar-cart").find("form");
        cartFormElement.html(drawerHtml);
        loadingBar.addClass("is-finished");

        /*Send custom event*/

        // We simply trigger an event so the mini-cart can re-render
        document.dispatchEvent(
          new CustomEvent("product:added", { detail: { quantity: 1 } })
        );
      });

      //  }
    },
    error: function (XMLHttpRequest, textStatus) {

    },
  });
}

function removeItemFromCart(variant_id, qty, properties) {
  var qty = qty || 0;

  var params = {};
  params[variant_id] = qty;

  jQuery.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: { updates: params },
    dataType: "json",
    success: function (response) {
      //   if(location.pathname === '/cart'){
      // location.reload()
      // }else{
      dispatchCartEvent(response);
      CartService.get(Date.now()).then((cart) => {
        const loadingBar = $(".LoadingBar");
        loadingBar.css("width", "100%");

        const cartElement = $($.parseHTML(cart));
        const drawerElement = cartElement.find("form");

        const drawerHtml = drawerElement.html();

        const cartFormElement = $("#sidebar-cart").find("form");
        cartFormElement.html(drawerHtml);
        loadingBar.addClass("is-finished");

        /*Send custom event*/

        // We simply trigger an event so the mini-cart can re-render
        document.dispatchEvent(
          new CustomEvent("product:added", { detail: { quantity: 1 } })
        );
      });
      //  }
    },
    error: function (XMLHttpRequest, textStatus) {
      console.log(textStatus);
    },
  });
}

function checkCartForItem(item_to_add_prod_id, cart) {
  let items = cart.items;
  // make a boolean to make sure that the item you want to add isnt already in the cart (to keep the JS from firing again on page reload)
  let item_in_cart_already = false;
  // product we are checking to see is in the cart

  //check the cart items and set boolean to true if the item is in the cart
  for (var i = 0; i < items.length; i++) {
    if (items[i].product_id == item_to_add_prod_id) {
      item_in_cart_already = true;
    }
  }

  return item_in_cart_already;
}

function isPromotionSampleInCart(item_to_add_prod_id, callback) {
  //get the cart
  let cart = $.getJSON("/cart.js");
  // wait for the response
  cart.done(function () {
    //when you have the response, get the JSON and set items to cart.items
    cart = cart.responseJSON;
    // make a boolean to make sure that the item you want to add isnt already in the cart (to keep the JS from firing again on page reload)
    let item_in_cart_already = checkCartForItem(item_to_add_prod_id, cart);
    callback(item_in_cart_already);
  });
}

function addPromotinoItem(item_to_add_prod_id, item_to_add_variant_id) {
  isPromotionSampleInCart(item_to_add_prod_id, function (item_in_cart_already) {
    if (!item_in_cart_already) {
      addItemToCart(item_to_add_variant_id, 1);
    }
  });
}

function removePromotionItem(item_to_add_prod_id, item_to_add_variant_id) {
  isPromotionSampleInCart(item_to_add_prod_id, function (item_in_cart_already) {
    if (item_in_cart_already) {
      removeItemFromCart(item_to_add_variant_id, 0);
    }
  });
}

window.addEventListener("cart-update-custom", function (data) {
  cartEventHandler(data);
});

class CartService {
  static getItems(timestamp) {
    return new Promise((resolve, reject) => {
      jQuery.getJSON(`/cart.js`).then((res) => {
        resolve(res.items);
      });
    });
  }

  static get(timestamp) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: "GET",
        url: `/cart?view=drawer&timestamp=${timestamp}&source=custom`,

        success: function (msg) {
          resolve(msg);
        },
        error: function () {
          alert(
            "Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available."
          );
          reject({ message: "Oops!" });
        },
      });
    });
  }

  static add(id) {
    return new Promise((resolve, reject) => {
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: id,
        },
        dataType: "json",
        success: function (data) {
          resolve(data);
        },
        error: function () {
          alert(
            "Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available."
          );
          reject({ message: "Oops!" });
        },
      });
    });
  }
}




class KlaviyoBis extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.bindEvents();


  }

  bindEvents(){
    const _this = this;
    $('[data-action="open-modal"]', this.element).on("click", function () {
      const title = this.dataset.title;
      const subtitle = this.dataset.subtitle;
      const id = this.dataset.id;
      document.querySelector('#klaviyoTitle').innerHTML = title;
      document.querySelector('#klaviyoSubtitle').innerHTML = subtitle;
      document.querySelector('#klaviyoId').value = id;
    });
  

    $('[data-action="handle-bis"]', this.element).on("click", function () {
      event.preventDefault();
      const email = document.querySelector('#klaviyoEmail').value;
      const id = document.querySelector('#klaviyoId').value;
      _this.sendData(email,id);
    });
  }


  sendData(email, id){
    $.ajax({
      type: "POST",
      url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
      data: {
          a: window.theme.klaviyoAPI, // Klaviyo account public token
          email: email, // Email address entered in form
          variant: id, // ID of the out of stock product variant about which customer wants to be notified.
          platform: "shopify"
      },
      success: function(){
        document.querySelector('#klaviyoForm').remove();
        document.querySelector('.modal-desc').remove();
        document.querySelector('.klavyioSuccess').setAttribute('aria-hidden', false);
      }
  })
  }


  
}
customElements.define("klaviyo-handler", KlaviyoBis);



class Complimentary extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    var _this = this;
    var $this = $(this);
    _this.initGWP();

    
    $this.on('click', '.complimentaryProduct', function(){
      _this.handleATCSubmit(this);
      });

    if(!document.querySelector('[data-section-id="cart"]').getAttribute('event-attached')){
      document.querySelector('[data-section-id="cart"]').setAttribute('event-attached','true');
      document.addEventListener("cart:rerender", function () {
        _this.initGWP();
     
      });
    }
   

 
  }

  initGWP(){
    this.removed = false;
    this.cartData = JSON.parse(document.querySelector('[data-section-type="cart"]').getAttribute('data-section-settings'));
    this.options = JSON.parse(this.element.getAttribute('data-settings'));

    if (this.options['treshold_method'] == '1' && this.options['treshold_value'] && this.options['treshold_value']*100 > this.cartData['itemAmount']){
      this.element.remove();
      this.removed = true;
    }
    if (this.options['treshold_method'] == '2' && this.options['treshold_value'] && this.options['treshold_value'] > this.cartData['itemCount']){
      this.element.remove();
      this.removed = true;
    }
    if (this.options['treshold_method'] == '3' && this.options['buy_x_get_y'] && !document.querySelector('[data-buyx]')){
      this.element.remove();
      this.removed = true;
    }   

    if (this.removed == true){
      this.removeAllGWP();
    }
    
    this.initFlickity();
  }

  initFlickity(){

    var _this = this;
    var elem = this.element.querySelector('.complimentaryFlickity');
    setTimeout(() => {
      var flkty = new Flickity( elem, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true
      });
      
      this.element.style.opacity = 1;

    }, 100);

  }


  removeAllGWP(){

    const alreadyAdded = document.querySelectorAll('[data-gwp]');
    var toRemove = { updates: {} };

    if(!alreadyAdded.length){return;}
    alreadyAdded.forEach((item, i) => {
      const myId = item.querySelector('.CartItem__Remove').getAttribute('data-line-id');
      toRemove.updates[myId] = 0;
    })



    fetch(window.theme.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify(toRemove),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
      if (response.ok) {

  
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              quantity: 0,
            }
          })
        );
      } 
    });
  }

  handleGWPclear(toRemove){
    
    fetch(window.theme.localeRootUrl + "/cart/update.js", {
      body: JSON.stringify(toRemove),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
      if (response.ok) {

  
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              quantity: 0,
            }
          })
        );
      } 
    });
  }

  handleATCSubmit(element) {

  
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
  
    var addToCartButton = $(element);
    addToCartButton.attr("disabled");
    let data = [];
    data = {
      id: $(element).attr('data-id'),
      quantity: 1
    }

    const alreadyAdded = document.querySelectorAll('[data-gwp]');
    var toRemove = { updates: {} };


    alreadyAdded.forEach((item, i) => {
      const myId = item.querySelector('.CartItem__Remove').getAttribute('data-line-id');
      toRemove.updates[myId] = 0;
      toRemove.updates[$(element).attr('data-id')] = 1;
    })


    if (alreadyAdded.length >= this.options['complimentary_range']){

      this.handleGWPclear(toRemove);
      return;
    }


    if(toRemove.updates.length > 0){
      this.handleGWPclear(toRemove);
      return;
    }
    

    

    fetch(window.theme.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(data),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
      },
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
      if (response.ok) {
        addToCartButton.removeAttr("disabled");
  
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: data.id,
              quantity: data.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement("span");
          errorMessageElement.className = "ProductForm__Error Alert Alert--error";
          errorMessageElement.innerHTML = content["description"];
          addToCartButton.removeAttr("disabled");
          addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });
  }


}
customElements.define("complimentary-product", Complimentary);


class GiftWrap extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    var $this = $(this);
    this.removed = false;
    var _this = this;
    $this.on("click", ".giftWrapper", function(){
      _this.handleGiftWrapping(this);
      });


      if(!document.querySelector('[data-section-id="cart"]').getAttribute('event-gift')){
        document.querySelector('[data-section-id="cart"]').setAttribute('event-gift','true');
        document.addEventListener("cart:rerender", function () {
          _this.initGift();
       
        });
      }
    
    }



  initGift(){
    var _this = this;
    this.cartData = JSON.parse(document.querySelector('[data-section-type="cart"]').getAttribute('data-section-settings'));
    this.options = JSON.parse(this.element.getAttribute('data-settings'));

    console.log(this.cartData['itemAmount'], this.options['treshold_value'] * 100);
      if(this.options['treshold_value'] * 100 >= this.cartData['itemAmount']){
        this.removeGiftWrapp();
      }
  }

  handleGiftWrapping(){
    this.options = JSON.parse(this.element.getAttribute('data-settings'));
    this.cartData = JSON.parse(document.querySelector('[data-section-type="cart"]').getAttribute('data-section-settings'));
    if(this.options['treshold_value'] * 100 <= this.cartData['itemAmount']){
      this.addGiftWrap(this);
    } else {
      this.showMsg();
    }
  }

  showMsg(){
    this.element.querySelector('.giftWrapper__error').style.display = "block";
    this.element.querySelector('.giftWrapper__subtitle').style.display = "none";
  }

  removeGiftWrapp(){
    const giftWrapp = document.querySelector('[data-giftwrap]');
    if (!giftWrapp){ return }
      
      
      var toRemove = { updates: {} };


        const myId = giftWrapp.querySelector('.CartItem__Remove').getAttribute('data-line-id');
        toRemove.updates[myId] = 0;


      

      fetch(window.theme.localeRootUrl + "/cart/update.js", {
        body: JSON.stringify(toRemove),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
        if (response.ok) {
  
    
          document.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                quantity: 0,
              }
            })
          );
        } 
      });
  
  }


  addGiftWrap(element){
    var addToCartButton = $(element);
    addToCartButton.attr("disabled");
    let data = [];
    data = {
      id: this.options['gift_wrap_product'],
      quantity: 1
    }

    fetch(window.theme.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(data),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
      },
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
      if (response.ok) {
        addToCartButton.removeAttr("disabled");
  
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: data.id,
              quantity: data.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement("span");
          errorMessageElement.className = "ProductForm__Error Alert Alert--error";
          errorMessageElement.innerHTML = content["description"];
          addToCartButton.removeAttr("disabled");
          addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });
  }

}
customElements.define("gift-wrapping", GiftWrap);